import React, { useEffect, useMemo, useState } from "react";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { connect } from "react-redux";
import PageTitle from "../../ui-library/HeaderTitles/PageTitle";
import {
  mapStateToProps,
  smartPageHeaderReducer,
  mapDispatchToProps,
} from "./PageHeader.store";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import SmartContactInformationForm from "../ContactInformationForm/ContactInformationForm";
import CustomModal from "../../ui-library/CustomModal/CustomModal";
import { profiles } from "../../../modules/constants";
import { useTranslation } from "react-i18next";
import { sessionLanguage } from "../../../config";
import { getCurrentLocale, refreshAppLanguage } from "../../../i18n/helpers";

export const SmartPageHeader = (props) => {
  const {
    studies,
    username,
    role,
    title,
    subtitle,
    getUserInfo,
    shouldFetchParticipant,
    resetState,
    fetchParticipant,
    participantId,
    studyId,
    canViewPersonalData,
    sites,
    participantUgnxId,
    participantLanguage,
  } = props;

  const { t } = useTranslation();

  const [showContactInfoModal, setShowContactInfoModal] = useState(false);

  useEffect(() => {
    if (
      participantLanguage &&
      participantLanguage !== getCurrentLocale() &&
      role === profiles.participant
    ) {
      sessionStorage.setItem(sessionLanguage, participantLanguage);

      refreshAppLanguage();
    }
  }, [participantLanguage, role]);

  useEffect(() => {
    if (shouldFetchParticipant) {
      fetchParticipant(participantId);
    } else {
      getUserInfo();
    }
  }, [
    getUserInfo,
    fetchParticipant,
    shouldFetchParticipant,
    username,
    studies,
    participantId,
  ]);

  useEffect(() => {
    return () => {
      resetState();
    };
  }, [resetState]);

  const onCloseUpdateParticipant = () => {
    fetchParticipant(participantId);
    setShowContactInfoModal(false);
  };

  const closeContactInfoModal = () => {
    setShowContactInfoModal(false);
  };

  const currentSite = useMemo(() => {
    return sites && sites.length > 0 ? sites[0].name : "";
  }, [sites]);

  return (
    <div data-testid="smart-page-header">
      <PageTitle
        title={title ?? ""}
        subtitle={subtitle || ""}
        roleName={role}
        id={username}
        participantUgnxId={shouldFetchParticipant ? participantUgnxId : null}
        showContactInfo={
          canViewPersonalData && role === profiles.participant && !participantId
        }
        setShowContactInfoModal={(val) => setShowContactInfoModal(val)}
        site={currentSite}
      />

      <CustomModal
        show={showContactInfoModal}
        title={t("contentText.contactInformation.title")}
        onClose={closeContactInfoModal}
      >
        <SmartContactInformationForm
          onSubmit={onCloseUpdateParticipant}
          onClose={closeContactInfoModal}
          studyId={studyId}
          shouldFetchParticipant
        />
      </CustomModal>
    </div>
  );
};

export default dynamic(
  "smartPageHeaderReducer",
  subspaced({
    mapExtraState: (state) => ({
      loginReducer: state.loginReducer,
    }),
  }),
  attachReducer(smartPageHeaderReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartPageHeader));
